module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "reportsFilters"
  }, [_c('div', [_c('date-picker', {
    attrs: {
      "placeholder": "Fra dato",
      "valueType": "format"
    },
    on: {
      "change": function($event) {
        return _vm.onFilterChange()
      }
    },
    model: {
      value: (_vm.archive.filter.startDate),
      callback: function($$v) {
        _vm.$set(_vm.archive.filter, "startDate", $$v)
      },
      expression: "archive.filter.startDate"
    }
  })], 1), _vm._v(" "), _c('div', [_c('date-picker', {
    attrs: {
      "placeholder": "Til dato",
      "valueType": "format"
    },
    on: {
      "change": function($event) {
        return _vm.onFilterChange()
      }
    },
    model: {
      value: (_vm.archive.filter.endDate),
      callback: function($$v) {
        _vm.$set(_vm.archive.filter, "endDate", $$v)
      },
      expression: "archive.filter.endDate"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.search),
      expression: "archive.filter.search"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.archive.filter.search)
    },
    on: {
      "change": function($event) {
        return _vm.onFilterChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.archive.filter, "search", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Søk")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.searchFirm),
      expression: "archive.filter.searchFirm"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "searchFirm"
    },
    domProps: {
      "value": (_vm.archive.filter.searchFirm)
    },
    on: {
      "change": function($event) {
        return _vm.onFilterChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.archive.filter, "searchFirm", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "searchFirm"
    }
  }, [_vm._v("Søk etter firma")])])]), _vm._v(" "), [_c('div', {
    staticClass: "type-of-reports"
  }, [(_vm.$root.isAdministrator() || _vm.$root.isClient()) ? [_c('div', {
    staticClass: "type-of-reports__by-user-type"
  }, [(_vm.$root.isAdministrator() && !_vm.$root.isEuropcarDenmark()) ? _c('div', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.archive.filter.onlyRegularReports ? 'is-checked' : ''],
    attrs: {
      "for": "only_regular_reports"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.onlyRegularReports),
      expression: "archive.filter.onlyRegularReports"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "only_regular_reports",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.archive.filter.onlyRegularReports) ? _vm._i(_vm.archive.filter.onlyRegularReports, null) > -1 : _vm._q(_vm.archive.filter.onlyRegularReports, "1")
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.archive.filter.onlyRegularReports,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.archive.filter, "onlyRegularReports", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.archive.filter, "onlyRegularReports", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.archive.filter, "onlyRegularReports", $$c)
        }
      }, function($event) {
        return _vm.onFilterChange()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Regular reports")])])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdministrator() && !_vm.$root.isEuropcarDenmark()) ? _c('div', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.archive.filter.onlyEuropcarReports ? 'is-checked' : ''],
    attrs: {
      "for": "only_europcar_reports"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.onlyEuropcarReports),
      expression: "archive.filter.onlyEuropcarReports"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "only_europcar_reports",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.archive.filter.onlyEuropcarReports) ? _vm._i(_vm.archive.filter.onlyEuropcarReports, null) > -1 : _vm._q(_vm.archive.filter.onlyEuropcarReports, "1")
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.archive.filter.onlyEuropcarReports,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.archive.filter, "onlyEuropcarReports", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.archive.filter, "onlyEuropcarReports", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.archive.filter, "onlyEuropcarReports", $$c)
        }
      }, function($event) {
        return _vm.onFilterChange()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("\n              Europcar reports")])])]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdministrator() || _vm.$root.isEuropcarDenmark()) ? _c('div', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.archive.filter.onlyEuropcarReportsDansk ? 'is-checked' : ''],
    attrs: {
      "for": "only_europcar_reports_dansk"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.onlyEuropcarReportsDansk),
      expression: "archive.filter.onlyEuropcarReportsDansk"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "only_europcar_reports_dansk",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.archive.filter.onlyEuropcarReportsDansk) ? _vm._i(_vm.archive.filter.onlyEuropcarReportsDansk, null) > -1 : _vm._q(_vm.archive.filter.onlyEuropcarReportsDansk, "1")
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.archive.filter.onlyEuropcarReportsDansk,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.archive.filter, "onlyEuropcarReportsDansk", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.archive.filter, "onlyEuropcarReportsDansk", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.archive.filter, "onlyEuropcarReportsDansk", $$c)
        }
      }, function($event) {
        return _vm.onFilterChange()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("\n              Europcar reports (dansk)")])])]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "type-of-reports__by-language"
  }, [_c('div', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.archive.filter.onlyNorskReports ? 'is-checked' : ''],
    attrs: {
      "for": "only_norsk_reports"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.onlyNorskReports),
      expression: "archive.filter.onlyNorskReports"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "only_norsk_reports",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.archive.filter.onlyNorskReports) ? _vm._i(_vm.archive.filter.onlyNorskReports, null) > -1 : _vm._q(_vm.archive.filter.onlyNorskReports, "1")
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.archive.filter.onlyNorskReports,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.archive.filter, "onlyNorskReports", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.archive.filter, "onlyNorskReports", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.archive.filter, "onlyNorskReports", $$c)
        }
      }, function($event) {
        return _vm.onFilterChange()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Norsk")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.archive.filter.onlyEngelskReports ? 'is-checked' : ''],
    attrs: {
      "for": "only_engelsk_reports"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.onlyEngelskReports),
      expression: "archive.filter.onlyEngelskReports"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "only_engelsk_reports",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.archive.filter.onlyEngelskReports) ? _vm._i(_vm.archive.filter.onlyEngelskReports, null) > -1 : _vm._q(_vm.archive.filter.onlyEngelskReports, "1")
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.archive.filter.onlyEngelskReports,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.archive.filter, "onlyEngelskReports", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.archive.filter, "onlyEngelskReports", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.archive.filter, "onlyEngelskReports", $$c)
        }
      }, function($event) {
        return _vm.onFilterChange()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Engelsk")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.archive.filter.onlyDanskReports ? 'is-checked' : ''],
    attrs: {
      "for": "only_dansk_reports"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.onlyDanskReports),
      expression: "archive.filter.onlyDanskReports"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "only_dansk_reports",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.archive.filter.onlyDanskReports) ? _vm._i(_vm.archive.filter.onlyDanskReports, null) > -1 : _vm._q(_vm.archive.filter.onlyDanskReports, "1")
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.archive.filter.onlyDanskReports,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.archive.filter, "onlyDanskReports", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.archive.filter, "onlyDanskReports", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.archive.filter, "onlyDanskReports", $$c)
        }
      }, function($event) {
        return _vm.onFilterChange()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Dansk")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    class: [_vm.archive.filter.onlySvenskReports ? 'is-checked' : ''],
    attrs: {
      "for": "only_svensk_reports"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archive.filter.onlySvenskReports),
      expression: "archive.filter.onlySvenskReports"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "id": "only_svensk_reports",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.archive.filter.onlySvenskReports) ? _vm._i(_vm.archive.filter.onlySvenskReports, null) > -1 : _vm._q(_vm.archive.filter.onlySvenskReports, "1")
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.archive.filter.onlySvenskReports,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.archive.filter, "onlySvenskReports", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.archive.filter, "onlySvenskReports", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.archive.filter, "onlySvenskReports", $$c)
        }
      }, function($event) {
        return _vm.onFilterChange()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v("Svensk")])])])])], 2)], _vm._v(" "), _c('div', [(_vm.isFilterActive()) ? _c('button', {
    staticClass: "reportsFilterBtn",
    on: {
      "click": _vm.clearFilter
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "reportsFilterBtn",
    attrs: {
      "target": "_blank",
      "href": _vm.exportUrl,
      "title": "Eksport"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_download")])])])], 2), _vm._v(" "), _c('table', {
    staticClass: "mdl-data-table mdl-shadow--2dp"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.reports), function(report) {
    return _c('tr', {
      class: [_vm.getSentColor(report.report_status, report.sent_at) + '-chip', _vm.isMadeByCurrentUser(report) ? '' : 'marked'],
      attrs: {
        "id": 'report-' + report.id
      },
      on: {
        "click": function($event) {
          return _vm.openReport(report)
        }
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.formatDate(report.created_at))
      }
    }), _vm._v(" "), (_vm.$root.isEuropcarCapability() || _vm.$root.isAldCapability() || _vm.$root.isRentalCheckCapability()) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getReportStatusLabel(report))
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.id)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.id_car.toUpperCase())
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.contact_name)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.firma)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s((report.producer ? report.producer : '') + ' ' + (report.model ? report.model : ''))
      }
    }), _vm._v(" "), (report.estimate > 0) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(report.estimate)
      }
    }) : _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric newpricing",
      domProps: {
        "textContent": _vm._s(report.lineitemsestimate)
      }
    }), _vm._v(" "), (report.report_status == 3) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller rejected",
      domProps: {
        "textContent": _vm._s(report.sent_at)
      }
    }, [_c('i', {
      staticClass: "material-icons mdl-list__item-icon"
    }, [_vm._v("person")])]) : (report.report_status == 2) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller preliminary",
      domProps: {
        "textContent": _vm._s(report.sent_at)
      }
    }) : (report.report_status == 1) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller confirmed",
      domProps: {
        "textContent": _vm._s(report.sent_at)
      }
    }) : (report.sent_at) ? _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller",
      domProps: {
        "textContent": _vm._s(report.sent_at)
      }
    }) : _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller"
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      domProps: {
        "textContent": _vm._s(_vm.getReportOwnerName(report))
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric smaller",
      domProps: {
        "textContent": _vm._s(_vm.getReportInshuranceCompany(report))
      }
    })])
  }), _vm._v(" "), (!_vm.reports.length && !_vm.$root.ui.isLoading()) ? _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No reports")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "reportsPagination"
  }, _vm._l((_vm.archive.pagesCount), function(i) {
    return (_vm.isPageVisible(i)) ? _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--icon mdl-button--colored",
      class: i == _vm.archive.filter.page ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.onPageChange(i)
        }
      }
    }, [_c('i', {
      domProps: {
        "textContent": _vm._s(i)
      }
    })]) : _vm._e()
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Rapport dato")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Reg.Nr")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Kontaktperson")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Firma")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Bil")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Skadekostnad")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Sendt")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Taksert av")]), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Forsikrings selskap")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a6c7de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/components/Reports.vue
// module id = 63
// module chunks = 0